import React, { createRef, useEffect } from "react";
import anime from "animejs/lib/anime.es.js";
import styled from 'styled-components';

import Layers from '@cover/motorstarten/motorstarten';

const StyledLayers = styled(Layers)`
	position: absolute;
`

const MotorStarten = ({ play }) => {
	const layers = createRef();

	useEffect(() => {
		const cloudBottomLeft = layers.current.querySelector('#motorstarten_svg__cloud-bottom-left')
		const cloudBottomRight = layers.current.querySelector('#motorstarten_svg__cloud-bottom-right')
		const car = layers.current.querySelector('#motorstarten_svg__car')
		const bike = layers.current.querySelector('#motorstarten_svg__bike')
		const lamp = layers.current.querySelector('#motorstarten_svg__lamp')
		const meditate = layers.current.querySelector('#motorstarten_svg__mediating-woman')
		const skydive = layers.current.querySelector('#motorstarten_svg__skydiver-man')
		const skate = layers.current.querySelector('#motorstarten_svg__skating-woman')

		anime({
			targets: skydive,
			autoplay: play,
			duration: 7000,
			loop: true,
			direction: 'alternate',
			easing: 'easeInOutSine',
			keyframes: [
				{translateY: '-0.8%', translateX: '0%'},
				{translateY: '-1%', translateX: '1%'},
				{translateY: '0%', translateX: '0%'}
			]
		});
		anime({
			targets: skate,
			autoplay: play,
			duration: 4000,
			loop: true,
			direction: 'alternate',
			easing: 'easeInOutSine',
			keyframes: [
				{translateY: '0.8%', translateX: '0%'},
				{translateY: '0%', translateX: '0%'}
			]
		});
		anime({
			targets: lamp,
			autoplay: play,
			duration: 5500,
			loop: true,
			direction: 'alternate',
			easing: 'easeInOutSine',
			keyframes: [
				{translateY: '1%', translateX: '-1.1%', rotate: 0},
				{translateY: '0%', translateX: '0%', rotate: 0}
			]
		});
		anime({
			targets: bike,
			autoplay: play,
			duration: 4000,
			loop: true,
			direction: 'alternate',
			easing: 'easeInOutSine',
			keyframes: [
				{translateY: '0%', translateX: '1.1%'},
				{translateY: '0.8%', translateX: '0.7%'},
				{translateY: '0%', translateX: '0%'}
			]
		});
		anime({
			targets: car,
			autoplay: play,
			duration: 5000,
			loop: true,
			direction: 'alternate',
			easing: 'easeInOutSine',
			keyframes: [
				{translateY: '-0.5%', translateX: '-0.4%'},
				{translateY: '-0.8', translateX: '0.4%'},
				{translateY: '0%', translateX: '0%'}
			]
		});
		anime({
			targets: cloudBottomLeft,
			autoplay: play,
			duration: 5000,
			loop: true,
			direction: 'alternate',
			easing: 'easeInOutSine',
			keyframes: [
				{translateY: '0.9%', translateX: '-0.9%'},
				{translateY: '0%', translateX: '0%'}
			]
		});
		anime({
			targets: cloudBottomRight,
			autoplay: play,
			duration: 4500,
			loop: true,
			direction: 'alternate',
			easing: 'easeInOutSine',
			keyframes: [
				{translateY: '-0.7%', translateX: '0.4%'},
				{translateY: '0%', translateX: '0.6%'},
				{translateY: '0%', translateX: '0%'}
			]
		});
	}, [play])
	return (
		<>
			<StyledLayers ref={layers}/>
		</>
	)
};

export default MotorStarten;